import { Injectable, inject } from '@angular/core';
import {EmployeeView, ProblemInstance, ProblemInstanceService} from "planner-shared";
import {DropdownItem} from "@shared";
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class RosterService {
    private readonly problemInstance = inject(ProblemInstanceService);


    public getRosterNameById(rosterId: string, problemInstance?: ProblemInstance): string {
        let rosterName = "";
        if (problemInstance) {
            rosterName = this.getRosterName(rosterId, problemInstance);
        } else {
            this.problemInstance.getProblemInstance().subscribe(instanceResult => {
                rosterName = this.getRosterName(rosterId, instanceResult.problemInstance);
            });
        }
        return rosterName;
    }

    public getRosterDropdownItems(): Observable<DropdownItem[]> {
        const rosterDepartments: Array<DropdownItem> = [];
        this.problemInstance.getProblemInstance().subscribe(instanceResult => {
            instanceResult.problemInstance.rosterDepartments.forEach(roster =>
                rosterDepartments.push(<DropdownItem>{
                    value: roster.rosterDepartmentId,
                    label: roster.rosterDepartmentName
                }));
        });
        return of(rosterDepartments);
    }

    public areEmployeesRosterMissingCase(employees: EmployeeView[]): Observable<boolean> {
        const noRosterEmployees = !employees.every(employee => employee.rosterDepartmentName);
        return this.problemInstance.rosterDepartmentIsPartOfInstance()
            .pipe(
                map(rosterPresent => {
                    return noRosterEmployees && rosterPresent;
                })
            );
    }

    public areDifferentRosterTasksOnEmployee(employee: EmployeeView): Observable<boolean> {
        return this.problemInstance.getProblemInstance().pipe(
            map(instanceResult => {
                const rosterSet = new Set();

                const employeeTasks =
                    instanceResult.problemInstance.emTasksNotPatients
                        .filter(task => task.employeeId === employee.employeeId);
                employeeTasks.forEach(task => rosterSet.add(task.rosterDepartmentId));

                return rosterSet.size > 1 || !employeeTasks.every(task => task.rosterDepartmentId === employee.rosterDepartmentId);
            })
        );
    }

    private getRosterName(rosterId: string, problemInstance: ProblemInstance): string {
        let rosterName = "";
        if (problemInstance.rosterDepartments) {
            const roster = problemInstance.rosterDepartments
                .find(roster => roster.rosterDepartmentId === rosterId);
            if (roster && roster.rosterDepartmentName) {
                rosterName = roster.rosterDepartmentName;
            }
        }
        return rosterName;
    }
}
